import { render, staticRenderFns } from "./declareDetail.vue?vue&type=template&id=494bb0ca&scoped=true&"
import script from "./declareDetail.vue?vue&type=script&lang=js&"
export * from "./declareDetail.vue?vue&type=script&lang=js&"
import style0 from "./declareDetail.vue?vue&type=style&index=0&id=494bb0ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494bb0ca",
  null
  
)

export default component.exports